import React from "react";
import ViewSwitchTab from "./ViewSwitchTab";
import IgdbGamesTab from "./IgdbGamesTab";
import IgdbPlatformsTab from "./IgdbPlatformsTab";

const VIEWS = [
  { key: "games", label: "Games", component: IgdbGamesTab },
  { key: "platforms", label: "Platforms", component: IgdbPlatformsTab },
];

// The IGDB caches: games_igdb and the platform_igdb crosswalk.
function IgdbTab(props) {
  return <ViewSwitchTab kicker="Curated source" title="IGDB" label="IGDB view" views={VIEWS} {...props} />;
}

export default IgdbTab;
